import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import LinkButton from '@atlaskit/button/link';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';

import { RecentWorkList } from './recent-work/RecentWorkList';

const messages = defineMessages({
	recentWorkHeading: {
		id: 'user-profile-card.recent-work.heading',
		defaultMessage: 'Recent work',
		description: 'Section title for recent work smart links on the user profile card',
	},
	viewAll: {
		id: 'user-profile-card.RecentWorkSection.viewAll',
		defaultMessage: 'View all',
		description:
			'Label on the link beside the recent work heading that opens the full list of the user\u2019s recent work on their profile page',
	},
});

interface RecentWorkSectionProps {
	recentWorkData: string[];
	testId?: string;
	viewAllUrl?: string;
	onLinkClick?: (url: string, index: number) => void;
	onViewAllLinkClick?: () => void;
}

export function RecentWorkSection({
	recentWorkData,
	testId,
	viewAllUrl,
	onLinkClick,
	onViewAllLinkClick,
}: RecentWorkSectionProps): React.JSX.Element | null {
	const intl = useIntl();

	if (recentWorkData.length === 0) {
		return null;
	}

	return (
		<Stack space="space.075">
			<Inline spread="space-between" alignBlock="center">
				<Text as="p" weight="medium" color="color.text">
					{intl.formatMessage(messages.recentWorkHeading)}
				</Text>
				{viewAllUrl && (
					<LinkButton
						href={viewAllUrl}
						onClick={onViewAllLinkClick}
						spacing="compact"
						appearance="subtle"
						testId={testId ? `${testId}-view-all` : undefined}
					>
						{intl.formatMessage(messages.viewAll)}
					</LinkButton>
				)}
			</Inline>
			<Box testId={testId}>
				<RecentWorkList urls={recentWorkData} maxSources={3} onLinkClick={onLinkClick} />
			</Box>
		</Stack>
	);
}
